import { AiOutlineExclamation } from "react-icons/ai";
import { BsLink, BsFillAlarmFill, BsFillCursorFill } from "react-icons/bs";
import {
    FaChartPie,
    FaCheck,
    FaTimes,
    FaUsers,
    FaHome,
    FaBarcode,
    FaCheckCircle,
    FaTimesCircle,
    FaGripLinesVertical,
    FaPrint,
    FaHourglass,
    FaCopy,
    FaRegFilePdf,
    FaArrowAltCircleUp,
    FaTrash,
    FaFileAlt,
    FaShoppingCart,
    FaBriefcase,
    FaFileInvoice,
    FaGlobeAmericas,
    FaMap,
    FaMapPin,
    FaEnvelope,
    FaGripLines,
    FaWarehouse,
    FaUser,
    FaCubes,
    FaInfoCircle
} from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import { ImQrcode, ImPrinter } from "react-icons/im";
import { RiAlertFill, RiLockPasswordFill, RiMessage3Fill } from "react-icons/ri";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import { IoChevronBackCircleOutline } from "react-icons/io5";
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import CopyrightOutlinedIcon from '@mui/icons-material/CopyrightOutlined';

import { MdSystemUpdate } from "react-icons/md";
import { BsFillUnlockFill, BsFillLockFill } from "react-icons/bs";



/**
 * @author IKlapouch
 * 07/02/2021
 */

export const IconSwitch = ({
    name,
    color,
    size,
    fontSize,
    isHeader,
}) => {
    size = isHeader ? 13 : size ? size : 17;
    fontSize = isHeader ? "inherit" : fontSize ? fontSize : "medium";

    /**
     * react-icons/fa      -> size
     * @mui/icons-material -> fontSize
     **/

    /**
     * @mui/icons-material
     * fontSize(String)
     * -inherit
     * -large
     * -medium
     * -small
     **/

    const faProps = { size, color };
    const muiProps = { fontSize, color };

    return (
        <>
            {/* Utilizar no "yes" e "no" */}
            {name === "positive" && (
                <FaCheck size={size} color={color ? color : "#5cb85c"} />
            )}
            {name === "negative" && (
                <FaTimes size={size} color={color ? color : "#d9534f"} />
            )}

            {name === "alert" && (
                <RiAlertFill size={size} color={color ? color : "#d9534f"} />
            )}

            {name === "unLock" && (
                <BsFillLockFill size={size} color={color ? color : "#d9534f"} />
            )}

            {name === "lock" && (
                <BsFillUnlockFill size={size} color={color ? color : "#5cb85c"} />
            )}


            {/* Block status Icon */}
            {name === "block" && <AiOutlineExclamation size={size} color={color ? color : "#d9534f"} />}

            {/* Status Icon */}
            {name === "active" && <FaCheckCircle size={size} color={color ? color : "#5cb85c"} />}
            {name === "canceled" && <FaTimesCircle size={size} color={color ? color : "#d9534f"} />}

            {/*Operetors icon */}
            {(name === "user") && (
                <FaUser {...faProps} />
            )}

            {/* Qtty Icon */}
            {(name === "qtty" || name === "positionsQty") && (
                <FaChartPie {...faProps} />
            )}

            {/* QRCode Icon */}
            {(name === "qrCode") && (
                <ImQrcode  {...muiProps} />
            )}

            {/* Date Icon */}
            {(name === "date") && (
                <CalendarTodayOutlinedIcon {...muiProps} />
            )}

            {/* Url Icon */}
            {(name === "url") && <BsLink {...muiProps} />}

            {/* Menu Icon */}
            {name === "menu" && <GiHamburgerMenu {...muiProps} />}

            {/* Homepage Icon */}
            {name === "homePage" && <FaHome {...faProps} />}

            {/* BarCode Icon */}
            {(name === "barCode" || name === "code") && <FaBarcode {...faProps} />}

            {/* Passworld Icon */}
            {(name === "password") && <RiLockPasswordFill {...muiProps} />}

            {/* Message icon */}
            {name === "message" && <RiMessage3Fill {...muiProps} />}

            {/* Column Icon */}
            {(name === "column") && <FaGripLinesVertical {...faProps} />}

            {/* Address Icon */}
            {name === "address" && <HomeOutlinedIcon {...muiProps} />}

            {/* Printer Icon */}
            {name === "print" && <ImPrinter {...muiProps} />}

            {/* Phone Icon */}
            {name === "phone" && <CallOutlinedIcon  {...muiProps} />}

            {/*Print Icon*/}
            {name === "reprint" && <FaPrint {...faProps} />}

            {/*Hourglass Icon*/}
            {name === "hourglass" && <FaHourglass {...faProps} />}

            {/*Copy Icon*/}
            {name === 'copy' && <FaCopy {...faProps} />}

            {/*Go Back Icon*/}
            {name === 'goBack' && <IoChevronBackCircleOutline {...muiProps} />}

            {/* PDF */}
            {name === 'pdf' && <FaRegFilePdf {...faProps} />}

            {/* CopyRight */}
            {name === 'copyRight' && <CopyrightOutlinedIcon {...muiProps} />}

            {/* Inventario icones status */}

            {name === "Planejado" && (<BsFillAlarmFill size={size} color={color ? color : "#5cb85c"} />)}

            {name === "Cancelado" && (<FaTimesCircle size={size} color={color ? color : "#d9534f"} />)}

            {name === "Pronto para Contagem" && (<FaCheckCircle size={size} color={color ? color : "#5cb85c"} />)}

            {name === "Importado Dispositivo" && (<MdSystemUpdate size={size} color={color ? color : "#5cb85c"} />)}

            {name === "Finalizado e Integrado com ERP" && (<BsFillCursorFill size={size} color={color ? color : "#5cb85c"} />)}

            {name === "Finalizada Contagem" && (<FaArrowAltCircleUp size={size} color={color ? color : "#5cb85c"} />)}

            {name === "description" && (<FaFileAlt size={size} color={color ? color : "#000000"} />)}

            {name === "product" && <FaShoppingCart fontSize={fontSize} />}

            {name === "company" && <FaBriefcase fontSize={fontSize} />}

            {name === "cnpj" && <FaFileInvoice fontSize={fontSize} />}

            {name === "country" && <FaGlobeAmericas fontSize={fontSize} />}

            {name === "map" && <FaMap fontSize={fontSize} />}

            {name === "cep" && <FaMapPin fontSize={fontSize} />}

            {name === "email" && <FaEnvelope fontSize={fontSize} />}

            {name === "level" && <FaGripLines fontSize={fontSize} />}

            {name === "profile" && <FaUsers fontSize={fontSize} />}

            {name === "module" && <FaCubes fontSize={fontSize} />}

            {name === "status" && <FaInfoCircle fontSize={fontSize} />}

            {/* Inventario icones status */}
            {/* Delete*/ name === 'delete' && <FaTrash {...faProps} />}
        </>
    );
};
